module.exports = __webpack_public_path__ + "static/001.thumb-1f93e343e144defd9f7ac10676845b64.jpg";